<template>
  <vx-card class="editor-mid-card">
    <!-- <vue-perfect-scrollbar class="scroll-area" :settings="settings"> -->
    <div class="mb-base">
      <div class="flex justify-between flex-wrap">
        <vs-row vs-w="6">
          <h3 class="float-left mr-4">
            {{ $t("editor.careerHistory.title") }}
          </h3>
          <vx-tooltip v-if="saveInProgress" text="Saving to cloud...">
            <feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
              svgClasses="text-success"
          /></vx-tooltip>
          <vx-tooltip v-else :text="$t('editor.careerHistory.saveToCloud')"
            ><feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
          /></vx-tooltip>
        </vs-row>
        <div>
          <options
            :previousMove="{ name: 'editor-contact' }"
            :nextMove="{ name: 'editor-educational-qualifications' }"
          />
        </div>
      </div>
      <!-- <p v-if="!isUserLoggedIn" class="text-danger">
          You are not authenticated. Please login to save your data.
        </p>
        <p v-else-if="internetConnectionStatus">
          Internet Connection Active. Keep editing and your data gets auto-saved.
        </p>
        <p v-else class="text-danger">
          No Internet Connection. Please connect to Internet to save your data.
        </p> -->
    </div>

    <div class="mb-2">
      <div>
        <div v-if="careerHistory.length" class="career-history-block">
          <VuePerfectScrollbar class="scroll-area--list" :settings="settings">
            <draggable
              v-model="careerHistory"
              :disabled="draggableDisabled"
              class="list-groupp"
              ghost-class="ghostt"
              :move="checkMove"
              @start="dragging = true"
              @change="updateOrder"
            >
              <vs-row
                class="mb-4"
                icon-pack="feather"
                icon="icon-move"
                :key="indextr"
                v-for="(tr, indextr) in careerHistory"
              >
                <vs-row>
                  <vs-col class="text-limited" v-if="tr.company" vs-w="3">
                    <feather-icon
                      icon="MoveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3 cursor-move"
                    />{{ tr.company }}
                  </vs-col>
                  <vs-col v-else vs-w="3"
                    ><feather-icon
                      icon="MoveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3 cursor-move"
                    />Edit data to view here</vs-col
                  >
                  <vs-col class="text-limited" vs-w="3">
                    {{ tr.title }}
                  </vs-col>
                  <!-- <vs-td v-else>None</vs-td> -->
                  <vs-col vs-w="2">
                    {{ formatDate2(tr.startDate) }}
                  </vs-col>
                  <!-- <vs-td v-else>None</vs-td> -->
                  <vs-col v-if="tr.currentlyActive" vs-w="2"> Present </vs-col>
                  <vs-col v-else vs-w="2">
                    {{ formatDate2(tr.endDate) }}
                  </vs-col>
                  <!-- <vs-td v-else>None</vs-td> -->
                  <vs-col class="whitespace-no-wrap flex items-center" vs-w="1">
                    <vx-tooltip
                      :text="$t('editor.careerHistory.tooltips.addPromotion')"
                      position="bottom"
                    >
                      <feather-icon
                        icon="ArrowUpCircleIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                        class="ml-2"
                        @click.stop="addPromotion(tr)"
                      />
                    </vx-tooltip>

                    <vx-tooltip
                      :text="
                        $t('editor.careerHistory.tooltips.editCareerHistory')
                      "
                      position="bottom"
                    >
                      <feather-icon
                        icon="EditIcon"
                        class="mx-1"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                        @click.stop="editCareerHistory(tr)"
                      />
                    </vx-tooltip>

                    <vx-tooltip
                      :text="
                        $t('editor.careerHistory.tooltips.deleteCareerHistory')
                      "
                      position="bottom"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                        @click.stop="deleteCareerHistory(tr._id)"
                      />
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
                <vs-row :key="indexpr" v-for="(pr, indexpr) in tr.promotions">
                  <vs-col class="text-limited" v-if="pr.company" vs-w="3">
                    <!--<feather-icon
                        icon="MoveIcon"
                        svgClasses="h-4 w-4"
                        class="mr-3 cursor-move"
                      />{{ pr.company }}-->
                  </vs-col>
                  <vs-col v-else vs-w="3"
                    ><feather-icon
                      icon="MoveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-3 cursor-move"
                    />{{
                      $t("editor.careerHistory.editDataToViewHere")
                    }}</vs-col
                  >
                  <vs-col class="text-limited" vs-w="3">
                    {{ pr.title }}
                  </vs-col>
                  <!-- <vs-td v-else>None</vs-td> -->
                  <vs-col vs-w="2">
                    {{ formatDate2(pr.startDate) }}
                  </vs-col>
                  <!-- <vs-td v-else>None</vs-td> -->
                  <vs-col v-if="pr.currentlyActive" vs-w="2"> Present </vs-col>
                  <vs-col v-else vs-w="2">
                    {{ formatDate2(pr.endDate) }}
                  </vs-col>
                  <!-- <vs-td v-else>None</vs-td> -->
                  <!-- <vs-col class="whitespace-no-wrap" vs-w="1">
                    <feather-icon
                        icon="ArrowUpCircleIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                        class="ml-2"
                        @click.stop="addPromotion(tr)"
                      />
                  </vs-col> -->
                  <vs-col
                    class="whitespace-no-wrap flex items-center justify-end"
                    vs-w="1"
                  >
                    <!-- <feather-icon
                      icon="ArrowUpCircleIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                      class="ml-2"
                      @click.stop="addPromotion(tr)"
                    /> -->
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                      @click.stop="editPromotion(pr)"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                      class="ml-2"
                      @click.stop="deletePromotion(tr._id, pr._key)"
                    />
                  </vs-col>
                </vs-row>
              </vs-row>
            </draggable>
          </VuePerfectScrollbar>
        </div>
        <div v-else class="items-center">
          {{ $t("editor.utils.noDataAvailable") }}
        </div>
      </div>
    </div>

    <div v-if="isUserLoggedIn" class="flex justify-between flex-wrap mb-base">
      <div>
        <p
          class="add-experience-btn text-primary font-bold"
          @click="addCareerHistory()"
        >
          <u>+ {{ $t("editor.careerHistory.addCareerHistory") }}</u>
        </p>
      </div>
      <div v-if="careerHistory && careerHistory.length > 0">
        <vs-checkbox
          v-model="localShowCareerHistoryOnMap"
          @change="saveShowCareerHistoryOnMap"
          ><small class="show-experience-on-mapp">
            {{ $t("editor.careerHistory.showCareerHistoryOnMap") }}
          </small>
        </vs-checkbox>
      </div>
    </div>
    <p v-else>
      <span v-if="organizationSlug === 'default'">
        <router-link :to="{ name: 'editor-about' }">{{
          $t("editor.careerHistory.login")
        }}</router-link>
        {{ $t("editor.careerHistory.toAddYourCareerHistory") }}
      </span>
      <span v-else>
        <router-link :to="{ name: 'editor-about-custom' }">{{
          $t("editor.careerHistory.login")
        }}</router-link>
        {{ $t("editor.careerHistory.toAddYourCareerHistory") }}
      </span>
    </p>

    <div v-if="addForm" class="main-form">
      <div class="vx-row">
        <div class="vx-col mb-base w-full md:w-1/2">
          <label
            >{{ $t("editor.careerHistory.company")
            }}<span class="required-field">*</span></label
          >
          <vs-input
            class="w-full dark-input-field"
            name="Company"
            maxlength="250"
            data-vv-validate-on="blur"
            v-validate="'required'"
            :disabled="
              disableInputField ||
              addPromotionInProgress ||
              editPromotionInProgress
            "
            v-model="localData.company"
            @input="saveField('saveCompany', 'Company')"
          />
          <span class="text-danger text-sm">{{ errors.first("Company") }}</span>
        </div>
        <div class="vx-col mb-base w-full md:w-1/2">
          <label
            >{{ $t("editor.careerHistory.title")
            }}<span class="required-field">*</span></label
          >
          <vs-input
            class="w-full dark-input-field"
            name="Career History"
            maxlength="250"
            data-vv-validate-on="blur"
            v-validate="'required'"
            :disabled="disableInputField"
            v-model="localData.title"
            @input="saveField('saveTitle', 'Title')"
          />
          <span class="text-danger text-sm">{{
            errors.first("Career History")
          }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mb-base w-full md:w-1/2">
          <div class="vx-row">
            <div class="vx-col mb-base w-full md:w-1/2">
              <label
                >{{ $t("editor.careerHistory.startDate")
                }}<span class="required-field">*</span></label
              >
              <vs-input
                v-validate="'required'"
                :max="localData.endDate ? localData.endDate : maxDate"
                onkeydown="event.preventDefault()"
                data-vv-validate-on="blur"
                name="Start Date"
                type="date"
                icon-no-border
                v-model="localData.startDate"
                class="w-full mr-3 dark-input-field"
                @blur="saveField('saveStartDate', 'Start Date')"
                :disabled="disableInputField"
              />
              <span class="text-danger text-sm">{{
                errors.first("Start Date")
              }}</span>
            </div>
            <div class="vx-col mb-base w-full md:w-1/2">
              <label
                >{{ $t("editor.careerHistory.endDate")
                }}<span class="required-field">*</span></label
              >
              <vs-input
                name="End Date"
                type="date"
                icon-no-border
                :min="localData.startDate"
                :max="maxDate"
                v-model="localData.endDate"
                onkeydown="event.preventDefault()"
                class="w-full mr-3 dark-input-field"
                @blur="saveField('saveEndDate')"
                :disabled="disableInputField || localData.currentlyActive"
              />
              <vs-checkbox
                class="mt-3"
                v-model="localData.currentlyActive"
                :disabled="disableInputField"
                @change="saveField('saveCurrentlyActive')"
              >
                <p class="currently-active">
                  {{ $t("editor.careerHistory.iCurrentlyWorkHere") }}
                </p>
              </vs-checkbox>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col mb-base w-full md:w-1/2">
              <label
                >{{ $t("editor.careerHistory.country")
                }}<span class="required-field">*</span></label
              >
              <v-select
                class="w-full"
                name="Country"
                v-model="localData.country"
                :options="countryCodes"
                :disabled="disableInputField"
                @input="saveField('saveCountry')"
              />
              <span class="text-danger text-sm">{{
                errors.first("Country")
              }}</span>
            </div>
            <div class="vx-col mb-base w-full md:w-1/2">
              <label
                >{{ $t("editor.careerHistory.city")
                }}<span class="required-field">*</span></label
              >
              <v-select
                class="w-full"
                name="City"
                v-model="localData.city"
                :options="cityList"
                :disabled="disableInputField || !localData.country"
                @input="saveField('saveCity')"
              />
              <span class="text-danger text-sm">{{
                errors.first("City")
              }}</span>
            </div>
          </div>
        </div>
        <div class="vx-col mb-base w-full md:w-1/2">
          <label>{{ $t("editor.careerHistory.description") }}</label>
          <vs-textarea
            class="w-full"
            name="Description"
            maxlength="2600"
            :disabled="disableInputField"
            v-model="localData.description"
            @input="saveField('saveDescription')"
          />
        </div>
      </div>
    </div>
    <!-- </vue-perfect-scrollbar> -->
  </vx-card>
</template>

<script>
import FeatherIcon from "../../components/FeatherIcon.vue";
import Options from "./components/Options.vue";
import constants from "@/constants";
import {
  saveInputFieldService,
  deleteDocumentService,
} from "@/services/editor/careerHistory.service.js";
import DataList from "./components/DataList.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import _ from "lodash";
import draggable from "vuedraggable";
import moment from "moment";
import countryCodes from "@/assets/data/country-codes.js";
import allCountriesCities from "@/assets/data/all-countries-cities.js";
import vSelect from "vue-select";

export default {
  components: {
    FeatherIcon,
    Options,
    DataList,
    VuePerfectScrollbar,
    draggable,
    vSelect,
  },
  name: "EditorContact",
  data() {
    return {
      localData: {},
      addForm: false,
      selectedCHRow: {},
      constants,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 40,
        wheelSpeed: 0.6,
      },
      draggableDisabled: false,
      countryCodes,
      allCountriesCities,
      localShowCareerHistoryOnMap: false,
      maxDate: "",
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    /*careerHistory() {
      return this.$store.state.editor.careerHistory;
    },*/
    careerHistory: {
      get: function () {
        return this.$store.state.editor.careerHistory;
      },
      set: function (newVal) {
        this.$store.commit("editor/SET_CAREER_HISTORY", newVal);
      },
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    scrollBarTag() {
      return "VuePerfectScrollbar";
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    cityList() {
      if (this.localData.country) {
        return this.allCountriesCities[this.localData.country.label];
      } else {
        return [];
      }
    },
  },
  watch: {
    usersData(newVal) {
      if (newVal) {
        this.localShowCareerHistoryOnMap = newVal.showCareerHistoryOnMap;
        // console.log('watch', this.localShowCareerHistoryOnMap);
      }
    },
    localData: {
      handler(newVal) {
        if (!newVal.country) {
          return (newVal.city = "");
        }
      },
      deep: true,
    },
  },
  methods: {
    _reset() {
      this.addPromotionInProgress = false;
      this.editPromotionInProgress = false;
      this.deletePromotionInProgress = -false;
      this.deletionCHId = null;
      this.deletionPrKey = null;
      this.addForm = false;
      this.localData = {};
    },
    updateOrder(e) {
      _.debounce(
        function (currentThis) {
          const newCareerHistory = currentThis.careerHistory.map(function (
            ch,
            index
          ) {
            return { _id: ch._id, oldSortId: ch.sortId, newSortId: index };
          });

          newCareerHistory.forEach((ch) => {
            currentThis.draggableDisabled = true;
            currentThis.$store
              .dispatch("editor/updateCareerHistoryOrder", {
                _id: ch._id,
                sortId: ch.newSortId,
              })
              .then((res) => {
                currentThis.draggableDisabled = false;
              });
          });
        },
        800,
        { leading: false, trailing: true }
      )(this);
    },
    checkMove: function (e) {
      // window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    formatDate(date) {
      if (date) {
        return date.split("T")[0];
      }
    },
    formatDate2(date) {
      if (date) {
        return moment(date).format("MMM YYYY");
      }
    },
    addCareerHistory() {
      this._reset();
      this.errors.clear();
      const sortId = this.careerHistory.length + 1;
      this.$store
        .dispatch("editor/createCareerHistory", { userId: this.userId, sortId })
        .then((res) => {
          this.localData = res.data;
          this.addForm = true;
          this.$forceUpdate();

          this.$vs.notify({
            title: "New Career History Created",
            text: "Start editing data and your data gets auto-saved.",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error creating a new Career History",
            text: "",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            fixed: false,
          });

          throw err;
        });
    },
    editCareerHistory(data) {
      this._reset();
      this.errors.clear();
      this.localData = JSON.parse(JSON.stringify(data));
      this.localData.startDate = this.formatDate(this.localData.startDate);
      this.localData.endDate = this.formatDate(this.localData.endDate);
      this.addForm = true;
    },
    deleteCareerHistory(id) {
      this._reset();
      this.errors.clear();

      this.deletionCHId = id;
      // // console.log(this.deletionCHId);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Career History entry?",
        acceptText: "Delete",
        accept: this.confirmDeleteCareerHistory,
      });
      this.addForm = false;
      this.localData = {};
    },
    confirmDeleteCareerHistory() {
      // this._reset();
      // this.errors.clear();

      // console.log(this.deletionCHId);

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        careerHistoryId: this.deletionCHId,
        currentThis: this,
      };

      // // console.log(payload);

      deleteDocumentService(payload);
    },
    addPromotion(ch) {
      this._reset();
      this.errors.clear();

      // const sortId = this.careerHistory.length + 1;
      this.addPromotionInProgress = true;
      this.localData = {
        careerHistoryId: ch._id,
        company: ch.company,
      };

      if (!ch.promotions) this.promotionKeyInProgress = 1;
      else this.promotionKeyInProgress = ch.promotions.length + 1;

      this.localData._key = this.promotionKeyInProgress;

      this.addForm = true;
    },
    editPromotion(pr) {
      this._reset();
      this.errors.clear();

      this.editPromotionInProgress = true;

      this.localData = {};
      this.localData = JSON.parse(JSON.stringify(pr));
      this.localData.startDate = this.formatDate(this.localData.startDate);
      this.localData.endDate = this.formatDate(this.localData.endDate);
      this.addForm = true;
    },
    deletePromotion(chId, _key) {
      this._reset();
      this.errors.clear();

      this.deletePromotionInProgress = true;

      this.deletionCHId = chId;
      this.deletionPrKey = _key;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Promotion entry?",
        acceptText: "Delete",
        accept: this.confirmDeletePromotion,
      });
      this.addForm = false;
      this.localData = {};
    },
    confirmDeletePromotion() {
      //this._reset();
      //this.errors.clear();

      this.localData.careerHistoryId = this.deletionCHId;
      this.localData = JSON.parse(
        JSON.stringify(
          this.careerHistory.find((ch) => ch._id === this.deletionCHId)
        )
      );
      let index = this.localData.promotions.findIndex((pr) => {
        return pr._key === this.deletionPrKey;
      });
      this.localData.promotions.splice(index, 1);
      // // console.log(this.localData);
      this.saveField("savePromotion");
    },
    async saveField(action, fieldName = null) {
      let fieldIsValid = false;
      if (fieldName === "Title") {
        fieldName = "Career History";
      }

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      if (this.addPromotionInProgress) {
        let currentPromotion = JSON.parse(JSON.stringify(this.localData));
        delete currentPromotion.promotions;
        if (this.promotionKeyInProgress === 1) {
          this.localData.promotions = [];
          this.localData.promotions.push(currentPromotion);
        } else {
          this.localData.promotions = JSON.parse(
            JSON.stringify(
              this.careerHistory.find(
                (ch) => ch._id === this.localData.careerHistoryId
              ).promotions
            )
          );
          let index = this.localData.promotions.findIndex((pr) => {
            return pr._key === this.promotionKeyInProgress;
          });
          if (index === -1) {
            this.localData.promotions.push(currentPromotion);
          } else {
            this.localData.promotions[index] = currentPromotion;
          }
        }
        action = "savePromotion";
      } else if (this.editPromotionInProgress) {
        let currentPromotion = JSON.parse(JSON.stringify(this.localData));
        delete currentPromotion.promotions;
        let _key = currentPromotion._key;
        let currentCH = JSON.parse(
          JSON.stringify(
            this.careerHistory.find(
              (pr) => pr._id == currentPromotion.careerHistoryId
            )
          )
        );
        let index = currentCH.promotions.findIndex((pr) => {
          return pr._key === _key;
        });
        currentCH.promotions[index] = currentPromotion;
        // this.localData = {};
        this.localData.careerHistoryId = currentCH._id;
        this.localData.promotions = currentCH.promotions;
        action = "savePromotion";
      } else if (this.deletePromotionInProgress) {
        action = "savePromotion";
      }

      // // console.log(this.localData);

      // return;

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        careerHistoryId: this.localData._id || this.localData.careerHistoryId,
        currentThis: this,
      };
      saveInputFieldService(payload);
    },
    saveShowCareerHistoryOnMap() {
      let payload = {
        _id: this.usersData._id,
        showCareerHistoryOnMap: this.localShowCareerHistoryOnMap,
      };
      // console.log(payload);
      this.$store
        .dispatch("users/saveShowCareerHistoryOnMap", payload)
        .catch((err) => {
          throw err;
        });
    },
    getTodayDate() {
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return (this.maxDate = [year, month, day].join("-"));
    },
  },
  mounted() {
    this.getTodayDate();
  },
  created() {
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);

    //// console.log("contact created");

    if (this.isUserLoggedIn) {
      if (Object.keys(this.usersData).length) {
        this.localShowCareerHistoryOnMap =
          this.usersData.showCareerHistoryOnMap;
        // console.log('created', this.localShowCareerHistoryOnMap);
      }
    }
  },
};
</script>

<style scoped>
.scroll-area--list {
  position: relative;
  margin: auto;
  height: 100px;
  width: 100%;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 615px;
  /*height: 1000px;*/
}

.career-history-block {
  background: #f7f7f7;
  border-radius: 6px;
  padding: 10px 2px 10px 25px;
  overflow-x: auto;
}

.show-experience-on-map {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: #7c7c7c;

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 12px 0px;
}

.currently-active {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  color: #7c7c7c;

  /* Inside Auto Layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 8px 0px;
}

.add-experience-btn {
  cursor: pointer;
}
.dark-input-field >>> .vs-con-input .vs-input--input {
  background: #edededab !important;
}
.vs-con-textarea >>> .vs-textarea {
  background: #edededab !important;
}
</style>
